import { render, staticRenderFns } from "./submitFormSuccess.vue?vue&type=template&id=0bc4217f&scoped=true&"
import script from "./submitFormSuccess.vue?vue&type=script&lang=js&"
export * from "./submitFormSuccess.vue?vue&type=script&lang=js&"
import style0 from "./submitFormSuccess.vue?vue&type=style&index=0&id=0bc4217f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc4217f",
  null
  
)

export default component.exports